export function loadFonts () {
  if (typeof window !== 'undefined' && window.webfontsloaded !== true) {
    let WebFont = require('webfontloader')
    WebFont.load({
      custom: {
        families: [
          'Circular Book:n4',
          'Circular Bold:n7'
        ],
        urls: [`${process.env.PUBLIC_URL}/fonts/fonts.css`]
      },
      active: () => {
        window.webfontsloaded = true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Helpers.js